import { render, staticRenderFns } from "./TopTenShareholder.vue?vue&type=template&id=3a260f95&scoped=true"
import script from "./TopTenShareholder.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTenShareholder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TopTenShareholder.vue?vue&type=style&index=0&id=3a260f95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a260f95",
  null
  
)

export default component.exports